import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';
import { router } from '../index.js';
Vue.use(Vuex);

const resourcesFeedModule = {
  namespaced: true,
  state: () => {
    return {
      searchTerm: '',
      resources: [],
      taxonomies: [],
      page: 0,
      activeTerms: [],
      title: '',
      fullyLoaded: false,
      loading: false,
      ppp: 9,
      currentTaxonomies: {}
    };
  },
  getters: {
    getField,
    getResources (state) {
      return state.resources;
    },
    getSearchTerm (state) {
      return state.searchTerm;
    },
    getTaxonomies (state) {
      return state.taxonomies;
    },
    getCurrentTaxonomies (state) {
      return state.currentTaxonomies;
    },
    getActiveTerms (state) {
      return state.activeTerms;
    },
    getLoading (state) {
      return state.loading;
    },
    getTitle (state) {
      return state.title;
    }
  },
  mutations: {
    updateField,
    updateSearchTerm: (state, payload) => {
      state.searchTerm = payload;
    },
    setResources: (state, payload) => {
      state.resources = payload;
    },
    setTaxonomies: (state, payload) => {
      state.taxonomies = payload;
    },
    updateResources: (state, payload) => {
      state.resources = payload;
    },
    updateActiveTerms: (state, payload) => {
      state.activeTerms = payload;
    },
    updateCurrentTaxonomies: (state, payload) => {
      if (Object.hasOwn(state.currentTaxonomies, payload.taxonomy)) {
        if (state.currentTaxonomies[payload.taxonomy].includes(payload.name)) {
          state.currentTaxonomies[payload.taxonomy] = state.currentTaxonomies[
            payload.taxonomy
          ].filter((item) => item !== payload.name);
          if (state.currentTaxonomies[payload.taxonomy].length === 0) {
            delete state.currentTaxonomies[payload.taxonomy];
            router.replace({ query: null });
          }
        } else {
          state.currentTaxonomies[payload.taxonomy].push(payload.name);
        }
      } else {
        state.currentTaxonomies[payload.taxonomy] = [payload.name];
      }
    },
    setFilters: (state, payload) => {
      state.currentTaxonomies = payload;
    },
    updatePage: (state, payload) => {
      state.page++;
    },
    resetPage: (state) => {
      state.page = 0;
    },
    resetResources: (state) => {
      state.resources = [];
    },
    updateLoading: (state, payload) => {
      state.loading = payload;
    },
    updateFullyLoaded: (state, payload) => {
      state.fullyLoaded = payload;
    },
    resetFullyLoaded: (state) => {
      state.fullyLoaded = false;
    },
    updateURL: (state) => {
      router.push({
        path: '/resources',
        name: 'Home',
        query: {
          filters: JSON.stringify(state.currentTaxonomies)
        }
      });
    },
    clearURL: () => {
      router.push({
        path: '/resources',
        name: 'Home'
      });
    }
  },
  actions: {
    updateSearchTerm: ({ commit }, payload) => {
      commit('updateSearchTerm', payload);
    },
    setFilters: ({ commit }, payload) => {
      commit('setFilters', payload);
    },
    updateURL: ({ commit }, payload) => {
      commit('updateURL', payload);
    },
    clearURL: ({ commit }, payload) => {
      commit('clearURL', payload);
    },
    resetFeed: ({ commit, dispatch }, payload) => {
      commit('resetPage');
      commit('resetFullyLoaded');
      commit('resetResources');
    },
    updateResources: ({ commit }, payload) => {
      commit('updateResources', payload);
    },
    updateCurrentTaxonomies: ({ commit }, payload) => {
      commit('updateCurrentTaxonomies', payload);
    },

    async returnResources ({ commit, state }) {
      state.title = state.searchTerm === '' ? 'Resources' : 'Search Results for ' + "'" + state.searchTerm + "'";
      if (state.loading) return false;
      if (state.fullyLoaded) return;
      commit('updateLoading', true);
      commit('updatePage');
      const { data, status } = await axios.get(
        '/wp-json/paraplanners/v1/posts',
        {
          params: {
            filters: state.currentTaxonomies,
            s: state.searchTerm,
            page: state.page,
            ppp: state.ppp
          }
        }
      );
        
      if (status === 200) {
        commit('updateLoading', false);
        commit('updateFullyLoaded', data.results.length < state.ppp);
        commit('setResources', [...state.resources, ...data.results]);
      }
    },
    async returnTaxonomies ({ commit }) {
      const { data, status } = await axios.get(
        '/wp-json/paraplanners/v1/posts/taxonomies'
      );

      if (status === 200) commit('setTaxonomies', data);
    }
  }
};

export default new Vuex.Store({
  modules: {
    rf: resourcesFeedModule
  }
});
